import { numberFormatter } from '@fortem-monorepo/js-utilities'
import { createColDefs } from '@fortem-monorepo/react-ag'
import { CustomAgGrid } from '@fortem-monorepo/react-ag'

import { ICReportTablePrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { beta } from '@/react-query/queries/ic-report/hooks'

const percentageFormatter = numberFormatter({
  suffix: '%',
  transformer: (val) => val * 100,
})

const colDefs = createColDefs([
  {
    field: 'region_wrapper',
    headerName: 'Region',
  },
  {
    headerName: 'Delta (%)',
    field: 'new_position_delta_risk_weight',
    valueFormatter: percentageFormatter,
  },
  {
    headerName: 'Delta Change (%)',
    field: 'position_delta_risk_weight_change',
    valueFormatter: percentageFormatter,
  },
  {
    headerName: 'Notional (%)',
    field: 'new_position_weight',
    valueFormatter: percentageFormatter,
  },
  {
    headerName: 'Notional Change (%)',
    field: 'position_weight_change',
    valueFormatter: percentageFormatter,
  },
])

export interface AggregatedBreakdownTableProps extends ICReportTablePrimitive {}

export const AggregatedBreakdownTable: React.FC<AggregatedBreakdownTableProps> = ({
  params,
  options,
}) => {
  const query = beta.useAggregatedBreakdown(params)
  const data = query.data

  return (
    <CustomAgGrid
      rowData={data}
      columnDefs={colDefs}
      autoSizeStrategy={{ type: 'fitCellContents' }}
      {...options}
    />
  )
}
